import { AxiosInstance } from 'axios';
import { OrderResponse, VoucherDetails } from 'types/order.type';

export class OrderService {
  private orderAgent: AxiosInstance;

  constructor(orderAgent: AxiosInstance) {
    this.orderAgent = orderAgent;
  }

  // check to see how this is called,
  // make a get call for new service
  public postNewOrder = async (
    order: any,
    customerDetails: any,
    orderDetails: any,
    captchaToken: string,
    useNewOrderEndpoint = false,
    eligibilityId: string | null = null,
    voucherDetails?: VoucherDetails,
    priceIncreaseNotice?: string
  ) => {
    let payload: any = {
      order,
      customerDetails: customerDetails,
      orderDetails: orderDetails,
      captchaToken: captchaToken,
      ...(eligibilityId ? { eligibilityId } : {}),
      useNewOrderEndpoint,
      voucherDetails,
      ...(priceIncreaseNotice ? { priceIncreaseNotice } : {}),
    };

    return (await this.orderAgent.post<OrderResponse>('/cart/newOrder', payload)).data;
  };

  public postReSendVerificationMail = async (accountNumber: string, email: string) => {
    let payload: any = {
      accountNumber,
      email,
    };

    return (await this.orderAgent.post('/cart/resendOrderVerificationProcessor', payload))?.data;
  };

  public getAbandonedCartData = async (RefId: string) => {
    let cartDetails = (
      await this.orderAgent.get<any>(`/cart/getAbandonedCartData`, { params: { RefId } })
    ).data;
    return cartDetails;
  };

  public sendEReciept = async (
    order: any,
    customerDetails: any,
    orderDetails: any,
    captchaToken: string,
    useNewOrderEndpoint = false,
    eligibilityId: string | null = null,
    accountNumber: string,
    voucherDetails?: VoucherDetails,
    priceIncreaseNotice?: string
  ) => {
    let payload: any = {
      order,
      customerDetails: customerDetails,
      orderDetails: orderDetails,
      captchaToken: captchaToken,
      ...(eligibilityId ? { eligibilityId } : {}),
      useNewOrderEndpoint,
      voucherDetails,
      accountNumber,
      ...(priceIncreaseNotice ? { priceIncreaseNotice } : {}),
    };

    return (await this.orderAgent.post<OrderResponse>('/cart/sendEReciept', payload)).data;
  };
}
